import { useRemoteBool } from '@mrkt/features/RemoteConfig';

/** check if current user is an employee */
export function useIsEmployee() {
  return useRemoteBool('employee');
}
